var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 596,
    height: 372,
    viewBox: "0 0 596 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M531.956 135.188H503.833C503.833 135.188 473.607 289.909 482.893 354.913L472.633 361.502L518.897 371.777L546.499 242.245L531.956 135.188Z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M515.773 262.158C515.773 285.511 520.744 306.994 529.075 324.018L546.5 242.245L538.669 184.594C524.697 202.94 515.773 230.87 515.773 262.158Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M515.773 134.045L580.026 130.32V199.977V371.775H534.183L539.522 362.206L515.773 134.045Z",
    fill: "#EDEEEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M539.522 362.208L515.773 134.047",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M520.844 19.8656V28.4471C520.844 35.0826 525.374 40.8609 531.818 42.4446L545.474 45.8011V12.2491L534.119 9.45827C530.921 8.67238 527.54 9.39995 524.949 11.4315C522.357 13.463 520.844 16.5729 520.844 19.8656V19.8656Z",
    fill: "#EDEEEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M520.844 28.4453C520.844 35.0809 525.374 40.8591 531.818 42.4429L545.474 45.7993",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M534.752 26.739C535.116 26.739 535.411 26.4441 535.411 26.0804C535.411 25.7167 535.116 25.4219 534.752 25.4219C534.389 25.4219 534.094 25.7167 534.094 26.0804C534.094 26.4441 534.389 26.739 534.752 26.739Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M524.643 26.739C525.007 26.739 525.301 26.4441 525.301 26.0804C525.301 25.7167 525.007 25.4219 524.643 25.4219C524.279 25.4219 523.984 25.7167 523.984 26.0804C523.984 26.4441 524.279 26.739 524.643 26.739Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M527.608 30.008V19.8594H522.523",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M535.998 19.865H530.914",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M543.852 25.0625V28.5868C545.753 28.5868 547.294 27.0456 547.294 25.1445C547.294 25.0389 547.289 24.9345 547.28 24.8312C547.087 22.6937 543.852 22.9162 543.852 25.0625Z",
    fill: "#EDEEEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M543.852 28.5829C545.753 28.5829 547.294 27.0417 547.294 25.1406",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M530.391 31.1953C530.818 31.6228 531.398 31.8629 532.002 31.8629C532.607 31.8629 533.187 31.6228 533.614 31.1953",
    stroke: "#73314F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M527.609 30.0156L529.833 30.5622",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M520.844 24.3154C520.844 24.3154 529.957 20.3687 532.394 15.2031V18.6855C532.394 18.6855 536.863 17.6408 538.314 15.5514C538.314 15.5514 539.078 23.2706 544.007 24.3154",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M545.475 35.5367C545.475 35.5367 557.005 26.9856 551.549 14.1007C546.093 1.21594 532.164 4.93048 519.627 6.09127C513.023 6.70278 504.711 4.31834 498.324 1.92479C492.284 -0.354997 485.466 1.68335 481.669 6.90382V6.90382C481.669 6.90382 470.758 1.91241 468.204 13.9847C465.65 26.0569 491.724 48.5187 526.512 39.8996",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M503.836 81.4029V135.186L580.027 153.913V94.0127C580.027 72.7733 565.527 54.2779 544.901 49.2085H544.901C535.01 46.7773 524.55 49.0281 516.534 55.3124C508.518 61.5968 503.836 71.2171 503.836 81.4028V81.4029Z",
    fill: "#73314F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M524.312 88.3193L440.75 122.884C431.959 126.52 424.241 132.339 418.327 139.791L406 155.322L430.454 155.31C437.705 155.306 444.886 153.892 451.598 151.146L535.958 116.628C540.465 114.784 543.826 110.905 545.009 106.181C546.192 101.457 545.056 96.4517 541.95 92.7009V92.7009C537.668 87.5297 530.516 85.753 524.312 88.3193Z",
    fill: "#EDEEEF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M406 155.32L430.454 155.307C437.705 155.303 444.886 153.889 451.598 151.143L535.958 116.625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M565.476 60.3828C565.476 60.3828 593.4 80.7278 594.328 124.838C595.257 168.948 503.832 107.426 503.832 107.426C503.832 107.426 497.75 107.713 495.661 101.069C495.661 101.069 491.714 100.842 492.179 99.1428C492.643 97.4432 503.322 90.9428 521.198 91.8714C539.075 92.8001 569.487 104.176 569.487 104.176",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M406 155.324L421.377 155.316C420.58 150.802 418.66 146.561 415.794 142.984L406 155.324Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M511.339 60.3828C511.339 60.3828 495.632 79.488 484.195 104.91",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M468.031 144.422C468.031 144.422 485.253 155.873 502.475 149.152",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M451.859 119.501C451.859 119.501 453.311 107.133 461.61 108.976C469.909 110.82 469.18 113.897 468.026 114.145C466.872 114.394 461.871 114.145 461.871 114.145L458.822 115.406",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M156.819 138.43L121.808 140.676L162.187 212.367L131.889 296.006L170.758 320.768L170.379 308.381C170.379 308.381 196.752 279.79 216.808 215.354C236.865 150.917 156.819 138.43 156.819 138.43Z",
    fill: "#E2E2E2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M186.368 203.832L162.471 199.565L156.441 202.166L162.187 212.367L155.944 229.599C155.944 229.599 181.489 239.981 195.824 268.171C197.008 265.801 198.205 263.321 199.414 260.73C195.554 239.723 186.368 203.832 186.368 203.832Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M297.858 126.546H186.439L194.082 59.7056H305.5L297.858 126.546Z",
    fill: "#EDEEEF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.434 120.845H182.015L189.657 54.0039H301.076L293.434 120.845Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M245.347 146.186L248.245 120.845H230.425L227.528 146.186H245.347Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M247.533 294.299C247.533 294.299 239.721 143.058 136.018 143.542L86.7961 155.641C86.7961 155.641 74.559 222.756 176.969 218.915L214.093 314.925L254.417 300.843L247.533 294.299Z",
    fill: "#EDEEEF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M247.533 294.299C247.533 294.299 239.721 143.058 136.018 143.542",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7961 155.641C86.7961 155.641 74.559 222.756 176.969 218.915L214.093 314.925",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M133.126 32.444V50.7165L110.49 56.2802V25.4443L133.126 19.8806V32.444Z",
    fill: "#EDEEEF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M120.339 38.7661C120.673 38.7661 120.944 38.4952 120.944 38.1609C120.944 37.8266 120.673 37.5557 120.339 37.5557C120.004 37.5557 119.733 37.8266 119.733 38.1609C119.733 38.4952 120.004 38.7661 120.339 38.7661Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M129.635 38.7661C129.969 38.7661 130.24 38.4952 130.24 38.1609C130.24 37.8266 129.969 37.5557 129.635 37.5557C129.3 37.5557 129.029 37.8266 129.029 38.1609C129.029 38.4952 129.3 38.7661 129.635 38.7661Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M126.907 41.7713V32.4438H131.58",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M119.198 32.4441H123.871",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M111.98 37.2232V40.4622C110.233 40.4622 108.817 39.0459 108.817 37.2987C108.817 37.2016 108.821 37.1056 108.83 37.0107C109.007 35.0462 111.98 35.2508 111.98 37.2232Z",
    fill: "#EDEEEF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M111.98 40.4622C110.233 40.4622 108.817 39.0458 108.817 37.2986",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M124.864 44.0706C123.095 44.0706 121.662 42.637 121.662 40.8687",
    stroke: "#275C61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M133.125 50.7166L110.489 56.2801",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M126.907 41.7788L124.864 42.2811",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M156.819 89.001V138.43L86.7959 155.641V100.59C86.7959 81.07 100.122 64.0719 119.078 59.4129H119.078C128.169 57.1785 137.782 59.2471 145.149 65.0227C152.516 70.7983 156.819 79.6399 156.819 89.001V89.001Z",
    fill: "#275C61"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M111.98 35.6364C113.717 33.5049 114.953 31.0116 115.6 28.3395C115.6 28.3395 129.029 32.7668 134.536 25.3524C137.032 21.9917 135.871 18.7124 134.7 16.7751C134.523 16.4679 134.198 16.2758 133.844 16.2687C133.489 16.262 133.157 16.4414 132.969 16.7415C132.424 17.6955 131.14 18.478 128.135 17.3512C123.071 15.4521 112.532 16.071 110.853 22.4719C110.853 22.4719 103.385 24.5522 109.8 35.7277",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M150.216 146.186H302.685",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M103.571 66.8074C103.571 66.8074 74.7072 90.5109 67.4528 128.822C60.1984 167.133 117.72 157.928 145.118 146.65",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9639 126.546C97.9639 126.546 163.04 115.043 167.521 143.542",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M147.225 66.8074C147.225 66.8074 167.647 87.8815 173.033 126.546C173.033 126.546 193.748 127.259 194.577 143.542",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5218 79.2965C91.5218 79.2965 82.24 60.0242 74.5588 76.6667C66.8777 93.3092 33.3145 202.979 68.7331 221.328C104.152 239.677 155.944 229.599 155.944 229.599",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M116.803 232.361V355.868H74.5591",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/Empty.f3f6d11804e32b305d35d738d34ceb85.svg";
export { ForwardRef as ReactComponent };